import {useState,useRef,useEffect} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import Select from 'react-select';
import {Maps} from './../../../js/prefix.js';
import styles from './../../../css/pc/login/login.module.scss';
import {loginWithPhonePwd,loginWithEmailPwd,getPersonalInfo,jsonpSso,getQCaptEncryptAppid} from './../../../service/loginService';
import { ToastContainer,toast ,Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import BindModal_PC from './bindModal';
import {useRouter} from 'next/router';
import {cx} from './../../../js/common';
import Cookies from 'js-cookie';
import {tencentCaptchaId} from './../../../config/config';

const customStyles = {
    container:(provided, state)=>({
        ...provided,
        width:150,
        fontSize:16,
    }), 
    valueContainer:(provided, state)=>({
        width:120,
        fontSize:16,
    }), 
    indicatorsContainer:(provided, state)=>({
        ...provided,
        fontSize:16,
    }), 
    indicatorSeparator:(provided, state)=>({
        ...provided,
        display:'none',
    }), 
    dropdownIndicator:(provided, state)=>({
        ...provided,
        paddingRight:0
    }),
    input:(provided, state)=>({
        ...provided,
        height:36,
        lineHeight:'36px',
        margin:0,
        padding:0,
        position:'absolute',
        top:'50%',
        transform:'translateY(-50%)',
    }),
    menu: (provided, state) => ({
        ...provided,
        width:200,
        borderBottom: '1px dotted pink',
        color: state.selectProps.menuColor,
        padding: 0,
        margin:0
    }),
    menuList:(provided, state)=>({
        ...provided,
        maxHeight:'200px'
    }), 
    option:(provided, state)=>({
        ...provided,
        fontSize:16,
        color:'#8691a7',
        background:state.isSelected||state.isFocused?'#f6f6f6':'none'
    }), 
    control: (_, { selectProps: { width }}) => ({
        display:'flex',

    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition ,width:'120px'};
    }
}
const Pwd_PC=(props)=>{
    try{
        const router=useRouter();
        const returnUrl=router.query.returnUrl?router.query.returnUrl:'https://www.fx168news.com';
        const sourceCode=router.query.sourceCode;
        const parameters=props.params;
        const flag=props.flag;
        const [selectedOption, setSelectedOption] = useState({value:props.prefix,label:props.prefix});
        const [captchaIns, setCaptchaIns] = useState('');
        const [id, setId] = useState('');
        const [mobile, setMobile] = useState('');
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('');
        const [code, setCode] = useState('');
        const [pwdStatus, setPwdStatus] = useState(false);
        //const [status, setStatus] = useState('phone');
        const [count, setCount] = useState(60);
        const [modalIsOpen, setIsOpen] = useState(false);
        const [loading, setLoading] = useState(false);
        let captchaLoaded=false;
        const handleSubmit=useRef();

        useEffect(()=>{
            setSelectedOption({value:props.prefix,label:props.prefix});
        },[props.prefix])

        useEffect(()=>{
            initCaptcha();
        },[]);

        // 定义回调函数
        const callback=(res)=> {
            if (res.ret === 0) {
                handleSubmit&&handleSubmit.current&&handleSubmit.current();
            }
        }
        // 定义验证码js加载错误处理函数
        const loadErrorCallback=() =>{
            var appid = tencentCaptchaId
            // 生成容灾票据或自行做其它处理
            var ticket = "terror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000)
            callback({
                ret: 300,
                randstr: "@" + Math.random().toString(36).substr(2),
                ticket: ticket,
                errorCode: 1001,
                errorMessage: "jsload_error"
            })
        }
        const initCaptcha=async()=>{
            try {
                const result=await getQCaptEncryptAppid({});
                if(result.code==0){
                    const captcha = new TencentCaptcha(tencentCaptchaId, callback, {aidEncrypted: result.data });
                    setCaptchaIns(captcha);
                    captchaLoaded=true;
                }else{
                    toast.error('获取腾讯云验证码加密appid失败',{toastId:'customId'});
                }
            } catch (error) {
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback()
            }
        }
        const bindStyles = {
            overlay:{
                backgroundColor:'rgba(0,0,0,0.5)'
            },
            content:{
                top:'50%',
                left:'50%',
                right:'auto',
                bottom:'auto',
                marginRight:'-50%',
                transform:'translate(-50%, -50%)',
                width:'9rem',
                height:'80%',
                padding:'0',
                borderRadius:'0.5rem'
            }
        };
        const closeBind=()=>{
            setIsOpen(false);
            if(returnUrl){
                location.href=returnUrl;
            }
        }
        const handleMobilePost=(e)=>{
            const val=e.target.value;
            setMobile(val);
        }
        const handleEmailPost=(e)=>{
            const val=e.target.value;
            setEmail(val);
        }
        const handlePassowordPost=(e)=>{
            const val=e.target.value;
            setPassword(val);
        }
        const checkForm=()=>{
            if(parameters.sourceStatus=='phone'){
                let reg=/^1[2|3|4|5|6|7|8|9]\d{9}$/;
                if(mobile===''){
                    toast.error("手机号不能为空！",{toastId:'customId'});
                    return false;
                }
                if(selectedOption.value=='中国+86'&&!reg.test(mobile)){
                    toast.error("请检查手机号码！",{toastId:'customId'});
                    return false;
                }
            }else{
                let reg=/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                if(email===''){
                    toast.error("邮箱/用户名不能为空！",{toastId:'customId'});
                    return false;
                }
                /*
                if(!reg.test(email)){
                    toast.error("请检查邮箱格式！",{toastId:'customId'});
                    return false;
                }*/
            }
            if(password===''){
                toast.error("密码不能为空！",{toastId:'customId'});
                return false;
            }
            return true;
        }
        const handleSSO=(list)=>{
            for(let i=0;i<list.length;i++){
                jsonpSso(list[i]);                  
            }
        }

        //提交登录
        handleSubmit.current=async()=>{
            if(loading){return ;}
            if(!checkForm()){return ;}
            let phone=selectedOption.value.split('+')[1]=='86'?mobile:('+'+selectedOption.value.split('+')[1]+mobile);
            const res=parameters.sourceStatus=='phone'?(await loginWithPhonePwd({mobile:phone,password:password,loginMedia:(!flag?1:2),version:'',sourceCode:sourceCode})):(await loginWithEmailPwd({account:email,password:password,loginMedia:(!flag?1:2),version:'',sourceCode:sourceCode}));
            setLoading(true);
            if(res.code==0){
                if(res.data&&res.data.isNeedBindMobile=='true'){
                    setIsOpen(true);
                }else{
                    toast.success("登录成功！",{toastId:'customId'});
                    if(returnUrl){
                        setTimeout(function(){location.href=returnUrl},1000);
                    }
                }
                Cookies.set('t',res.data.t,{expires:7,path:'/',domain:document.domain.split('.').slice(-2).join('.'),secure:true});
                handleSSO(res.data.sso);
            }else{
                toast.error(res.data||'登录失败！',{toastId:'customId'});
            }
            setLoading(false);
        }
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                event.preventDefault(); // 阻止默认的回车键行为
                captchaIns && captchaIns.show();
            }
        };
        return (
            <div onKeyDown={(e)=>{handleKeyDown(e)}}>  
                {parameters.sourceStatus=='phone'?<div className={styles.phoneItem}>
                    <Select
                        placeholder="请选择地区"
                        defaultValue={Maps[0]}
                        value={selectedOption}
                        onChange={(val)=>{setSelectedOption(val);localStorage.setItem("countryPrefix", val['value']);props.setPrefix(val['value'])}}
                        options={Maps}
                        styles={customStyles}
                        noOptionsMessage={()=>'没有搜索结果'}
                        className={styles.select}
                        classNamePrefix="selectPrefix"
                    />
                    <span className={styles.divider}></span>
                    <input type="text" className={styles.phoneInput}  value={mobile} onChange={handleMobilePost} placeholder="手机号" />
                </div>:<div className={styles.emailItem}>
                    <input type="text" className={styles.emailInput} value={email} onChange={handleEmailPost} placeholder="邮箱/用户名" />
                </div>}                
                <div className={styles.pwdItem}>
                    <input type={pwdStatus?"text":'password'} className={styles.pwdInput}  value={password} onChange={handlePassowordPost} placeholder="输入密码" />
                    {!pwdStatus?(
                        <span className={styles.hideEye} onClick={()=>{setPwdStatus(true)}}></span>
                    ):(
                        <span className={styles.showEye} onClick={()=>{setPwdStatus(false)}}></span>
                    )}
                </div>
                <div className={styles.statusItem}>
                    <span className={styles.loginWayBtn} onClick={()=>{parameters.setSourceStatus(parameters.sourceStatus=='phone'?'email':'phone')}}>{parameters.sourceStatus=='phone'?'邮箱或用户名登录':'手机号登录'}</span>
                    <span className={styles.forgetBtn} onClick={()=>{parameters.setStatus('reset')}}>忘记密码?</span>
                </div>
                <div className={styles.submitItem}>
                    <button onClick={()=>{captchaIns && captchaIns.show()}} disabled={loading}>{loading?'登录中...':'登录'}</button>
                </div>
                <div className={styles.tipsItem}>
                    注册/登录代表您已阅读并同意<Link href="/agreement/agreement"><a target="_blank">《用户协议》</a></Link>和<Link href="/agreement/privacy"><a target="_blank">《隐私政策》</a></Link>
                </div>
                <div className={cx(styles.tipsItem,styles.tipsBottom)} >
                    邮箱和用户名密码登录后请绑定手机号，这两种登录方式即将被废弃
                </div>

                <BindModal_PC params={{modalIsOpen:modalIsOpen,setIsOpen:setIsOpen,closeBind:closeBind,returnUrl:returnUrl}} flag={flag} prefix={props.prefix} setPrefix={props.setPrefix} />
            </div>
        );
    }catch(e){
        console.log(e);
        return null;
    } 
};

export default Pwd_PC;
